(() => {
  const start = root => {
    const slider = root.querySelector('[data-lh-slider]');
    if (slider && !slider.dataset.ready) {
      slider.dataset.ready = 'true';
      const prev=root.querySelector('[data-lh-prev]'), next=root.querySelector('[data-lh-next]'), page=root.querySelector('[data-lh-page]');
      const cards=[...slider.children];
      const step=()=>cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(slider).gap);
      const update=()=>{const index=Math.round(slider.scrollLeft/step());const controls=prev.parentElement;controls.hidden=slider.scrollWidth<=slider.clientWidth+2;prev.disabled=slider.scrollLeft<2;next.disabled=slider.scrollLeft>=slider.scrollWidth-slider.clientWidth-2;page.textContent=`${Math.min(index+1,cards.length)} / ${cards.length}`;};
      const move=d=>slider.scrollBy({left:d*step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      slider.addEventListener('scroll',update,{passive:true});
      slider.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
      new ResizeObserver(update).observe(slider);update();
    }
  };
  start(document);
  document.addEventListener('shopify:section:load',e=>start(e.target));
  document.addEventListener('click',e=>{if(e.target.closest('[data-close-announcement]')){const banner=document.querySelector('[data-announcement]');if(banner)banner.hidden=true;}});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){const menu=document.querySelector('.mobile-nav[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
})();
